import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { createdriver } from "../../api/driver";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import storage from "../firebase.config";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchUserTerms, termsSelector } from "../../api/termsSlice";

function BasicForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    Driver_licence_number: "",
    Driver_licence_number_expiry_date: "",
    Driver_licence_link: ""
  });
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const termsState = useSelector(termsSelector);
  const { currentTerms } = termsState;
  const toggleTermsModal = () => {
    setShowTermsModal(!showTermsModal);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: id === "Driver_licence_number" ? value.toUpperCase() : value,
    }));
  };

  useEffect(() => {
    console.log("Calling fetchUserTerms...");
    dispatch(fetchUserTerms());
  }, [dispatch]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const forbiddenExtensions = ['.doc', '.docx', '.txt', '.rtf', '.odt'];
      const fileName = file.name.toLowerCase();

      const isForbidden = forbiddenExtensions.some(ext => fileName.endsWith(ext));

      if (isForbidden) {
        setAlertMessage("This file type is not allowed.");
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 5000);
        toast.error("Only PDF or valid files are accepted!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        e.target.value = ""; // reset file input
        return;
      }

      // Accept the file
      setSelectedFile(file);
    }
  };


  const uploadFile = async (file) => {
    try {
      const storageRef = ref(storage, `Driver-Documents/${file.name}`);
      await uploadBytes(storageRef, file);
      return await getDownloadURL(storageRef);
    } catch (error) {
      console.error("Upload failed:", error);
      throw new Error("License upload failed");
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validate phone number length
  if (formData.phone_number.length !== 10 || !/^\d{10}$/.test(formData.phone_number)) {
    setAlertMessage("Phone number must be exactly 10 digits.");
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
    return;
  }

  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.email)) {
    setAlertMessage("Please enter a valid email address.");
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
    return;
  }

  if (
    !formData.name ||
    !formData.email ||
    !formData.phone_number ||
    !formData.Driver_licence_number ||
    !formData.Driver_licence_number_expiry_date ||
    !selectedFile
  ) {
    setAlertMessage("Please fill out all fields and upload a driver's licence.");
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
    return;
  }

  try {
    setIsUploading(true);

    // Upload file to Firebase
    const driverLicenceUrl = await uploadFile(selectedFile);

    const payload = {
      ...formData,
      email: formData.email.toLowerCase(),
      phone_number: Number(formData.phone_number),
      Driver_licence_link: driverLicenceUrl
    };

    await dispatch(createdriver(payload));
    navigate("/signin");
  } catch (error) {
    console.error("Error:", error);
    setAlertMessage(error.message || "Failed to create driver. Please try again.");
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  } finally {
    setIsUploading(false);
  }
};

  console.log("Terms State:", termsState);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 relative mt-44">
      {showAlert && (
        <div className="absolute top-5 w-full max-w-md">
          <div className={`${alertMessage.includes("successfully") ? "bg-green-100 border-green-400 text-green-700" : "bg-red-100 border-red-400 text-red-700"} border p-4 rounded-lg shadow-md`}>
            <p className="font-bold">
              {alertMessage.includes("successfully") ? "Success" : "Error"}
            </p>
            <pre className="whitespace-pre-wrap">{alertMessage}</pre>
          </div>
        </div>
      )}

      {/* Terms & Conditions Modal */}
      {showTermsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 mt-48 ">
         <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] p-8 relative overflow-y-auto">

            <div className="flex justify-between items-start mb-4">
              <h3 className="text-2xl font-bold">Terms and Conditions</h3>
              <button
                onClick={toggleTermsModal}
                className="text-gray-500 hover:text-red-600 text-xl font-bold"
              >
                &times;
              </button>
            </div>
            {currentTerms && (
              <div className="max-h-[600px] overflow-auto">
                <div
                  dangerouslySetInnerHTML={{ __html: currentTerms }}
                  className="prose max-w-none"
                />
              </div>
            )}




            <div className="mt-6 text-right mb-10">
              <button
                onClick={toggleTermsModal}
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}


      <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
          Register
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Form fields remain the same */}

          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-600"
            >
              <span className="text-red-500">*</span>  Name
            </label>
            <input
              type="text"
              id="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your name"
            />
          </div>
          {/* Email Field */}
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-600"
            >
              <span className="text-red-500">*</span>  Email
            </label>
            <input
              type="email"
              id="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your email"
            />
          </div>
          {/* Phone Number Field */}
          <div className="mb-4">
            <label
              htmlFor="phone_number"
              className="block text-sm font-medium text-gray-600"
            >
              <span className="text-red-500">*</span>  Phone Number
            </label>
            <input
              type="tel"
              id="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              required
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your phone number"
            />
          </div>

          {/* DL Number Field */}
          <div className="mb-4">
            <label
              htmlFor="Driver_licence_number"
              className="block text-sm font-medium text-gray-600"
            >
              <span className="text-red-500">*</span> DL Number
            </label>
            <input
              type="text"
              id="Driver_licence_number"
              value={formData.Driver_licence_number}
              onChange={handleChange}
              required
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Enter your Driving Licence Number"
            />
          </div>

          {/* DL Expiry Date Field */}
          <div className="mb-4">
            <label
              htmlFor="Driver_licence_number_expiry_date"
              className="block text-sm font-medium text-gray-600"
            >
              <span className="text-red-500">*</span>   DL Expiry Date
            </label>
            <DatePicker
              selected={formData.Driver_licence_number_expiry_date}
              onChange={(date) =>
                setFormData({ ...formData, Driver_licence_number_expiry_date: date })
              }
              required
              dateFormat="dd/MM/yyyy"
              placeholderText="Select Licence Expiry Date"
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select" // this shows year/month as dropdowns
            />
          </div>


          {/* Driver's Licence Upload Field */}
          <div className="mb-4">
            <label htmlFor="driverLicence" className="block text-sm font-medium text-gray-600">
              <span className="text-red-500">*</span> Driver's Licence
            </label>
            <input
              type="file"
              id="driverLicence"
              required
              accept="image/*,.pdf"
              onChange={handleFileChange}
              className="w-full mt-1 p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <p className="text-sm text-gray-500 mt-1">
              Upload scanned copy of driver's licence (only Valid Document)
            </p>
          </div>

          <div className="mb-4 flex items-start gap-2">
            <input
              type="checkbox"
              id="terms"
              checked={formData.termsAccepted || false}
              onChange={(e) =>
                setFormData({ ...formData, termsAccepted: e.target.checked })
              }
              className="mt-1"
            />
            <label htmlFor="terms" className="text-sm text-gray-700">
              I agree to the{" "}
              <button
                type="button"
                onClick={toggleTermsModal}
                className="text-blue-600 underline hover:text-blue-800"
              >
                Terms and Conditions
              </button>
            </label>
          </div>


          <div className="mt-6">
            <button
              type="submit"
              disabled={isUploading || !formData.termsAccepted}
              className={`w-full bg-blue-500 text-white py-2 px-4 rounded-lg ${isUploading || !formData.termsAccepted ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
                } transition duration-200`}
            >
              {isUploading ? "Uploading..." : "Submit"}
            </button>
          </div>

        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/signin" className="text-blue-500 hover:underline transition duration-200">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default BasicForm;